import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateMyOrganization(
    $id: String!
    $data: updateOrganizationInput!
  ) {
    updateOrganization(id: $id, data: $data) {
      error {
        statusCode
        message
      }
      id
      status
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateMyOrganizationRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateOrganizationInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/update_my_organization',
  async (
  params: {id: String;data: TYPES.UpdateOrganizationInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateOrganization;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateMyOrganizationSlice = createSlice({
  name: 'update_my_organization',
  initialState: initialState,
  reducers: {
    updateMyOrganizationClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateMyOrganizationRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateMyOrganizationRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateMyOrganizationRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateMyOrganizationClear } =
updateMyOrganizationSlice.actions;

export const updateMyOrganization = createSelector(
  (state: RootState) => state.organization.updateMyOrganization.result,
  (state: RootState) => state.organization.updateMyOrganization.error,
  (state: RootState) => state.organization.updateMyOrganization.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateMyOrganizationSlice.reducer;